import { BasicDropdownType, TableCols } from '../interfaces/static-data';

const mapToDropdownItem = (items: string[]): BasicDropdownType[] => {
  return items.map((item: string) => ({
    id: item,
    displayValue: item
      .split('_')
      .reduce(
        (acc, current) =>
          acc.concat(
            current.charAt(0).toUpperCase() + current.toLowerCase().slice(1)
          ),
        []
      )
      .join(' '),
  }));
};

export const TRANSACTION_TYPE_ITEMS = mapToDropdownItem([
  'STANDARD_NORTH_AMERICAN_CORPORATE',
  'STANDARD_EUROPEAN_CORPORATE',
  'STANDARD_EUROPEAN_FINANCIAL_CORPORATE',
  'STANDARD_EUROPEAN_COCO_FINANCIAL_CORPORATE',
  'STANDARD_AUSTRALIA_CORPORATE',
  'STANDARD_AUSTRALIA_FINANCIAL_CORPORATE',
  'STANDARD_NEW_ZEALAND_CORPORATE',
  'STANDARD_NEW_ZEALAND_FINANCIAL_CORPORATE',
  'STANDARD_JAPAN_CORPORATE',
  'STANDARD_JAPAN_FINANCIAL_CORPORATE',
  'STANDARD_SINGAPORE_CORPORATE',
  'STANDARD_SINGAPORE_FINANCIAL_CORPORATE',
  'STANDARD_ASIA_CORPORATE',
  'STANDARD_ASIA_FINANCIAL_CORPORATE',
  'STANDARD_SUBORDINATED_EUROPEAN_INSURANCE_CORPORATE',
  'STANDARD_EMERGING_EUROPEAN_CORPORATE_LPN',
  'STANDARD_EMERGING_EUROPEAN_CORPORATE',
  'STANDARD_LATIN_AMERICA_CORPORATE_B',
  'STANDARD_LATIN_AMERICA_CORPORATE_L',
  'STANDARD_SUKUK_CORPORATE',
  'STANDARD_ASIA_SOVEREIGN',
  'STANDARD_EMERGING_EUROPEAN_&_MIDDLE_EASTERN_SOVEREIGN',
  'STANDARD_JAPAN_SOVEREIGN',
  'STANDARD_AUSTRALIA_SOVEREIGN',
  'STANDARD_NEW_ZEALAND_SOVEREIGN',
  'STANDARD_SINGAPORE_SOVEREIGN',
  'STANDARD_LATIN_AMERICA_SOVEREIGN',
  'STANDARD_WESTERN_EUROPEAN_SOVEREIGN',
  'STANDARD_SUKUK_SOVEREIGN',
  'STANDARD_US_MUNICIPAL_FULL_FAITH_AND_CREDIT',
  'STANDARD_US_MUNICIPAL_GENERAL_FUND',
  'STANDARD_US_MUNICIPAL_REVENUE',
  'STANDARD_EUROPEAN_SENIOR_NON_PREFERRED_FINANCIAL_CORPORATE',
]);

export const SENIORITY_LEVEL_ITEMS = mapToDropdownItem([
  'SENIOR',
  'SUBORDINATED',
  'SENIOR_NON_PREFERRED',
]);

export const REFERENCE_OBLIGATION: TableCols[] = [
  {
    key: 'longName',
    displayValue: 'Name',
  },
  {
    key: 'referenceEntityID',
    displayValue: 'Reference Entity',
    type: 'select',
  },
  {
    key: 'primaryObligor',
    displayValue: 'Primary Obligor',
  },
  {
    key: 'guarantor',
    displayValue: 'Guarantor(s)',
    type: 'select',
    selectOptions: {
      allowFreeText: true,
      multiple: true,
      searchable: true,
      isCommaSeparated: true,
    },
  },
  {
    key: 'isin',
    displayValue: 'Reference ISIN',
  },

  {
    key: 'maximumMaturity',
    displayValue: 'Maximum Maturity',
  },
  {
    key: 'maturityDate',
    displayValue: 'Maturity Date',
    type: 'date',
  },
  {
    key: 'seniorityLevel',
    displayValue: 'Seniority Level',
    type: 'select',
    items: SENIORITY_LEVEL_ITEMS,
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'transactionType',
    displayValue: 'Transaction Type',
    type: 'select',
    items: [],
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'currency',
    displayValue: 'Currency',
    type: 'select',
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'domesticCurrency',
    displayValue: 'Domestic Currency',
    type: 'select',
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'coupon',
    displayValue: 'Coupon',
  },
];
